import { useOnboardingStore } from '@/store/onboardingStore';
import { ChipGroup } from '../components/ChipGroup';
import type { Role } from '@/types/onboarding';

/* ─── Screen 1: Who are you? ────────────────────────────────── */

const ROLE_OPTIONS: { value: Role; label: string; icon: string }[] = [
    { value: 'athlete', label: 'Athlete', icon: '🤼' },
    { value: 'parent', label: 'Parent', icon: '👨‍👩‍👦' },
    { value: 'coach', label: 'Coach', icon: '📋' },
];

export function RoleScreen() {
    const { profile, setRole, nextStep } = useOnboardingStore();

    const handleSelect = (role: Role | Role[]) => {
        const val = Array.isArray(role) ? role[0]! : role;
        setRole(val);
        // Auto-advance after 300ms
        setTimeout(nextStep, 300);
    };

    return (
        <div className="px-2">
            <h2 className="text-xl font-bold text-text-primary mb-2">
                Who are you?
            </h2>
            <p className="text-text-secondary text-sm mb-8">
                This helps us personalize your experience.
            </p>

            <ChipGroup
                options={ROLE_OPTIONS}
                selected={profile.role ?? 'athlete'}
                onChange={handleSelect}
                columns={3}
            />
        </div>
    );
}
